<template>
  <div>

    <xolas-table
       table-ref="requests-table"

       title="Requests"
       icon="fa fa-share-alt"

       hide-org-badge
       :show-search="false"

       :url="'/actions/site/' + rowData.id + '/null/rt'"

       :fields="fields"

       :layer-component="'request'"
       :layer-args="{ id: 'id' }">

      <!-- Same control RequestTable renders on /requests rows — same entity
           (RTx action), same DELETE /actions/{id}, same access rules. -->
      <template #rts-controls="props">
        <rtx-action-delete-control :row-data="props.rowData" table-ref="requests-table" />
      </template>

    </xolas-table>

  </div>

</template>


<script>
import DateMixins from '@/mixins/DateMixins'
import NumberMixins from '@/mixins/NumberMixins'

import XolasTable from '@/components/atoms/tables/XolasTable'
import RtxActionDeleteControl from '@/components/requests/RtxActionDeleteControl'

export default {

  mixins: [DateMixins, NumberMixins],


  components: {
    XolasTable,
    RtxActionDeleteControl
  },


  props: {

    rowData: {
      type: Object,
      required: true
    },

    editMode: {
      type: Boolean,
      default: false
    },

    readOnly: {
      type: Boolean,
      default: false
    }


  },



  data () {

    return {

      telcoId: this.isTelco() ? Number(this.org().id) : null,

      // Per-column widths so el-table doesn't evenly-distribute the columns
      // (matches the legacy vuetable content-based layout, and the sibling
      // SiteProgress table — XOL-231 PR 5b). The `#` sequence column is dropped
      // to match dev.
      fields: [
        {
          name: 'actionType',
          title: 'Type',
          minWidth: '90'
        },
        {
          name: 'status',
          title: 'Status',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down',
          minWidth: '150'
        },
        {
          name: 'priority',
          title: 'Priority',
          callback: this.formatPriority,
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
          minWidth: '100'
        },
        {
          name: 'organisation.shortName',
          title: 'Company',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
          minWidth: '120'
        },
        {
          name: 'targetDate',
          title: 'Target Date',
          callback: 'formatDate|DD MMM YYYY',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
          minWidth: '130'
        },
        {
          // Trash button only — narrow fixed column, mirroring RequestTable.
          // Tower Co only: the control itself also gates on
          // isManager('project') && isTowerCo(), but hiding the whole column
          // avoids an empty gutter for everyone else.
          name: '__slot:rts-controls',
          title: '',
          width: '60',
          visible: this.isTowerCo()
        }
      ]
    }

  }

}

</script>
